import VsCompare from "./VsCompare";

export default function VsTopProducer() {
  return (
    <VsCompare
      competitor="Top Producer"
      testId="vs-tp-page"
      slug="top-producer"
      seoTitle="iKEY vs. Top Producer — Modern CRM with AI Briefings"
      seoDescription="Compare iKEY and Top Producer. iKEY replaces the paperwork-heavy workflow with AI briefings, DocuSign built-in, and a modern mobile app."
      tagline="Top Producer runs on paperwork. iKEY runs on AI."
      rows={[
        { label: "Free forever tier",             ikey: true,                    them: false },
        { label: "E-signatures included",         ikey: "DocuSign built-in",     them: "Add-on / Authentisign" },
        { label: "AI 'Who to call today' briefing", ikey: true,                  them: "Rules-based reminders" },
        { label: "Branded client portal",         ikey: true,                    them: "Legacy IDX pages" },
        { label: "Native iOS + Android app",      ikey: true,                    them: "Aging iOS app" },
        { label: "Transaction deadline tracker",  ikey: true,                    them: true },
        { label: "CSV data export on Free",       ikey: true,                    them: "No free tier" },
      ]}
      pricing={[
        { tier: "Free",             ikey: "$0 · 1–3 clients (CRM only)",     them: "No free tier" },
        { tier: "Entry paid tier",  ikey: "$39.99/mo · Growth · 10 clients", them: "$60/mo · Business" },
        { tier: "Mid-tier",         ikey: "$79.99/mo · Master · 20 clients", them: "$85/mo · Business Plus" },
        { tier: "Top tier",         ikey: "$119.99/mo · Pro · unlimited",    them: "$180+/mo · Growth + Add-ons" },
        { tier: "DocuSign add-on",  ikey: "Included in every paid plan",     them: "$45–$85/mo extra (DocuSign)" },
      ]}
      chooseIkeyWhen={[
        "You want a modern, mobile-first CRM — Top Producer's UX and iOS app haven't been through a full redesign in years.",
        "You want AI in your CRM, not just reminders — iKEY's Run-My-Day drafts the opener; Top Producer surfaces a task list.",
        "You want e-signatures included — Top Producer's Authentisign integration is an add-on with its own line item.",
        "You want to start free without a card — Top Producer has no free tier.",
        "You want data portability on day one — every iKEY plan includes one-click CSV export.",
      ]}
      faq={[
        {
          q: "Can I migrate my Top Producer data into iKEY?",
          a: "Yes. Top Producer's Business tier includes CSV export for contacts and transactions; drop the file into iKEY's Import CSV screen and everything imports in one pass.",
        },
        {
          q: "Does iKEY support MLS integrations like Top Producer?",
          a: "iKEY pushes tailored listing recommendations into the client portal — different mental model from Top Producer's MLS clipping model, but it solves the same problem: get the right listings in front of the right buyer.",
        },
        {
          q: "Is iKEY's DocuSign the real DocuSign?",
          a: "Yes — the same DocuSign envelopes, certificates, and audit trail; you just don't manage a separate DocuSign subscription.",
        },
        {
          q: "How much cheaper is iKEY over a year?",
          a: "Top Producer Business ($60/mo) plus DocuSign Standard ($45/mo) is about $1,260/year. iKEY Growth is $479.88/year — roughly $780 saved. Annual billing on iKEY drops that another 18%.",
        },
      ]}
    />
  );
}
